export default __webpack_public_path__ + "static/media/template3.39714696.svg";